import { ChangeDetectionStrategy, Component, DestroyRef, input, inject, computed } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { EmployeeService } from '@coin/shared/auth/data-access';
import { UserState } from '@coin/shared/auth/feature';
import { EmployeePictureComponent, V2DualPillComponent } from '@coin/shared/core/ui-storybook';
import { TranslatePipe } from '@ngx-translate/core';
import { EmployeeDirect, EmployeeDirectMercerStandingValidationStateEnum } from '@coin/shared/core/util-models-v2';

@Component({
  selector: 'customer-app-direct-item-overview',
  templateUrl: './direct-item-overview.component.html',
  styleUrls: ['./direct-item-overview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [EmployeePictureComponent, V2DualPillComponent, TranslatePipe],
  host: {
    '(keydown.code.Enter)': 'goToDocumentCenter()',
    '(keydown.code.Space)': 'goToDocumentCenter()'
  }
})
export class DirectItemOverviewComponent {
  private readonly router = inject(Router);
  private readonly userState = inject(UserState);
  private readonly employeeService = inject(EmployeeService);
  private readonly destroyRef = inject(DestroyRef);

  direct = input(undefined, { transform: (e: EmployeeDirect) => structuredClone(e) });

  readonly openStateName = computed(() => {
    const state = this.direct()?.mercerStandingValidationState;
    const isOpen =
      state === EmployeeDirectMercerStandingValidationStateEnum.Open ||
      state === EmployeeDirectMercerStandingValidationStateEnum.Review;
    return isOpen ? `mercer-standing.state.${state}`.toLowerCase() : undefined;
  });

  goToDocumentCenter(): void {
    this.employeeService
      .getEmployeeDetails(this.userState.user()?.id)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(employee => {
        this.router.navigate(['/employee-detail-overview'], {
          queryParams: {
            receiverId: this.direct().id,
            managerId: employee?.id
          }
        });
      });
  }
}
